import {
  Box,
  Center,
  HStack,
  Image,
  VStack,
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  MenuGroup,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import logoTextImage from "../../assets/logo/Transparent-2.png";
import logoImage from "../../assets/logo/Transparent-1.png";
import { ChevronDownIcon } from "@chakra-ui/icons";

export default function NavMenu() {
  const isMobile = window.innerWidth <= 768; // Define your mobile breakpoint here
  const navigate = useNavigate();

  return (
    <>
      {isMobile ? (
        <VStack>
          <Box
            position="absolute"
            top={0}
            left={0}
            zIndex={10}
            mt={["4", "4"]}
            ml={["0", "4"]}
            p="1.5"
            color="#000"
            borderRadius={"15px"}
            backgroundColor="#f0f0f0"
            boxShadow={"inset 2px 2px 6px #bebebe, inset -2px -2px 6px #ffffff"}
          >
            <Image boxSize="35px" objectFit="contain" src={logoImage} />
          </Box>
        </VStack>
      ) : (
        //Desktop view
        <Box
          position="fixed"
          top={0}
          left={0}
          zIndex={10}
          mt={["4", "4"]}
          ml={["0", "4"]}
          p="1.5"
          color="#000"
          borderRadius={"15px"}
          backgroundColor="#f0f0f0"
          boxShadow={"inset 2px 2px 6px #bebebe, inset -2px -2px 6px #ffffff"}
        >
          <Menu>
            <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
              <Center>
                <HStack mt="-30px" mb="-35px">
                  <Image
                    boxSize="25px"
                    mr={"-10px"}
                    objectFit="contain"
                    src={logoImage}
                  />
                  <Image
                    boxSize="100px"
                    objectFit="contain"
                    src={logoTextImage}
                  />
                </HStack>
              </Center>
            </MenuButton>
            <MenuList borderRadius={"15px"}>
              <MenuItem
                onClick={() => {
                  navigate("/");
                }}
              >
                Home
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/contact-us");
                }}
              >
                Contact Us
              </MenuItem>
              <MenuGroup title="Routing APIs">
                <SimpleGrid columns={2}>
                  {/* <MenuItem
                    onClick={() => {
                      navigate("/routing-api");
                    }}
                  >
                    Routing
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/route-planner-api");
                    }}
                  >
                    Route Planner
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/route-matrix-api");
                    }}
                  >
                    Route Matrix
                  </MenuItem> */}

                  <MenuItem
                    onClick={() => {
                      navigate("/route-planner-api-v4");
                    }}
                  >
                    Route Planner V4
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/route-planner-api-v3");
                    }}
                  >
                    Route Planner V3
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/routing-api-v3");
                    }}
                  >
                    Routing V3
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/routing-api-v4");
                    }}
                  >
                    Routing V4
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/routing-2-api-v4");
                    }}
                  >
                    Routing-2 V4
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/route-matrix-api-v3");
                    }}
                  >
                    Route Matrix V3
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/route-matrix-api-v4");
                    }}
                  >
                    Route Matrix V4
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/route-matrix-2-api-v4");
                    }}
                  >
                    Route Matrix-2 V4
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/map-matching-api");
                    }}
                  >
                    Map Matching
                  </MenuItem>
                </SimpleGrid>
              </MenuGroup>
              <MenuGroup title="Geocoding APIs">
                <SimpleGrid columns={2}>
                  <MenuItem
                    onClick={() => {
                      navigate("/search-api");
                    }}
                  >
                    Search (Geocoding)
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/reverse-api");
                    }}
                  >
                    Reverse Geocoding
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/autocomplete-api");
                    }}
                  >
                    Autocomplete
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/place-api");
                    }}
                  >
                    Place
                  </MenuItem>
                </SimpleGrid>
              </MenuGroup>
              <MenuGroup title="Address APIs">
                <SimpleGrid columns={2}>
                  <MenuItem
                    onClick={() => {
                      navigate("/address-parsing-api");
                    }}
                  >
                    Address Parsing
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/address-validation-api");
                    }}
                  >
                    Address Validation
                  </MenuItem>
                </SimpleGrid>
              </MenuGroup>
              <MenuGroup title="Building Footprint APIs">
                <MenuItem
                  onClick={() => {
                    navigate("/buildings-api");
                  }}
                >
                  Buildings
                </MenuItem>
              </MenuGroup>
              <MenuGroup title="Imagery APIs">
                <MenuItem
                  onClick={() => {
                    navigate("/location-image-api");
                  }}
                >
                  Location Image
                </MenuItem>
              </MenuGroup>
            </MenuList>
          </Menu>
          <Center>
            <HStack></HStack>
          </Center>
        </Box>
      )}
    </>
  );
}
